import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './styles';

class ProgressButton extends React.Component {
    render() {
        const { active, classes, disabled } = this.props;

        return (
            <div className={classes.wrapper}>
                <Button variant="contained" color="primary" disabled={disabled || active} onClick={this.props.onClick}>
                    {this.props.text}
                </Button>
                {active && <CircularProgress size={24} className={classes.progress} />}
            </div>
        );
    }
}

export default withStyles(styles)(ProgressButton);